// EventsManager.js
var EventsManager = pc.createScript('eventsManager');

EventsManager.attributes.add("wordLetterGroup", {type: "entity"});
EventsManager.attributes.add("mathStatusBar", {type: "entity"});
EventsManager.attributes.add("mathOperator", {type: "entity"});
EventsManager.attributes.add("mathResult", {type: "entity"});
EventsManager.attributes.add("wordStatusBar", {type: "entity"});
EventsManager.attributes.add("wordTemplateLetter", {type: "entity"});
EventsManager.attributes.add("wordIcon", {type: "entity"});
EventsManager.attributes.add("gourmetStatusBar", {type: "entity"});
EventsManager.attributes.add("gourmetIconGroup", {type: "entity"});
EventsManager.attributes.add("gourmetTemplateIcon", {type: "entity"});
EventsManager.attributes.add("attentionStatusBar", {type: "entity"});
EventsManager.attributes.add("attentionMatchKeyword", {type: "entity"});
EventsManager.attributes.add("attentionIcon", {type: "entity"});
EventsManager.attributes.add("themeStatusBar", {type: "entity"});
EventsManager.attributes.add("themeTextStatusBar", {type: "entity"});
EventsManager.attributes.add("GameHomeButton", {type: "entity"});
EventsManager.attributes.add("EventsTopWall", {type: "entity"});
EventsManager.attributes.add("JokerWall", {type: "entity"});

let mathOperatorList = ["addition","subtraction","multiplication","division"];
var selectedWordKeys, cloneSelectedWordKeys;
var matchThemeAssetList = [];
var findByAttentionObjects = [];

EventsManager.prototype.initialize = function() {

    this.entity.on("destroy", this.OnDestroy,this);
    EventsManager.instance = this;
};


EventsManager.prototype.initMathChallange = function() {

    this.mathStatusBar.enabled = true;
    
    var num1,num2,operator,matchKey;
    
    num1 = Math.floor(Math.random() * 10);
    num2 = Math.floor(Math.random() * 10);
    operator = mathOperatorList[Math.floor(Math.random() * 4)];

    if (operator === "addition" || operator === "multiplication") {
        
        while (this.mathChallangeCheckOperationValid(num1,num2,operator) != true) {
            num1 = Math.floor(Math.random() * 10);
            num2 = Math.floor(Math.random() * 10);
        }
        matchKey = (operator === "addition") ? (num1 + num2) : (num1 * num2);
    }
    else if (operator === "subtraction") {
        matchKey = Math.floor(Math.random() * 7) + 1;
    }
    else if (operator === "division") {
        matchKey = Math.floor(Math.random() * 4) + 2; 
    }

    this.mathOperator.element.text = this.convertOperatorToCharacter(operator);
    this.mathResult.element.text = matchKey.toString();
    
    return [matchKey,operator];
};

EventsManager.prototype.initWordChallenge = function() {

    this.wordStatusBar.enabled = true;
    var wordArray = this.app.assets.find('WordGameData.json').resource.TiKey;
    var selectedWord = wordArray[Math.floor(Math.random() * wordArray.length)];

    var matchAsset = this.app.assets.findByTag(selectedWord)[0];
    //console.log("Seçili Kelime: " + selectedWord);
    
    selectedWordKeys = selectedWord.toUpperCase().split("");
    cloneSelectedWordKeys =  [...selectedWordKeys];
    
    for (i = 0; i < selectedWord.length-1; i++) {
        var e = this.wordTemplateLetter.clone();
        this.wordLetterGroup.addChild(e);
    }

    let wordImg = this.wordIcon;

     if (matchAsset.resource) {
        wordImg.enabled = true;
        wordImg.element.texture = matchAsset.resource;
    }
    else {
        matchAsset.on("load", function (asset) {
            wordImg.enabled = true;
            wordImg.element.texture = asset.resource;
        });

        this.app.assets.load(matchAsset);
    }
    return selectedWord;
};

EventsManager.prototype.attentionObjectUpdateStatus = function () {

    var matchAsset = this.app.assets.findByTag(findByAttentionObjects[0] + "UI");

    let icon = this.attentionIcon;

    if (matchAsset[0].resource) {
        icon.enabled = true;
        icon.element.texture = matchAsset[0].resource;
    }
    else {
        matchAsset[0].on("load", function (asset) {
            icon.enabled = true;
            icon.element.texture = asset.resource;
        });

        this.app.assets.load(matchAsset[0]);
    }

    this.attentionMatchKeyword.element.text = findByAttentionObjects[0];
};

EventsManager.prototype.initThemeChallenge2 = function () {

    this.themeStatusBar.enabled = true;
    var themeKeyArray = JSON.parse(GameManager.instance.eventData.matchKey);
    let themeKeyList = themeKeyArray.TiKey;
    let selectedIndex = Math.floor(Math.random() * themeKeyList.length);
    let selectedThemeKey = themeKeyList[selectedIndex];
    this.themeTextStatusBar.element.text = selectedThemeKey;
    
    return selectedThemeKey;

};


EventsManager.prototype.initAttentionChallenge = function() {
    
    this.attentionStatusBar.enabled = true;
    this.attentionObjectUpdateStatus();
};


EventsManager.prototype.initThemeChallenge = function () {

    this.themeStatusBar.enabled = true;
    this.themeTextStatusBar.element.text = GameManager.instance.eventData.matchKey;
};


function shuffle(array) {
  let currentIndex = array.length,  randomIndex;

  while (currentIndex != 0) {

    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

EventsManager.prototype.mathChallangeCheckOperationValid = function (num1, num2, operator) {

    if (num1 == num2) {
        return false;
    }
    else {
        if (operator == "addition") {
            return num1 + num2 > 0 ? true : false;
        }
        else {
            return num1 * num2 > 0 ? true : false;
        }
    }
};

EventsManager.prototype.wordChallengeShowMatchLetters = function(inputLetter) {
  
    for (i=0; i<selectedWordKeys.length; i++) {

        if (selectedWordKeys[i].toUpperCase() == inputLetter) {
            this.wordLetterGroup.children[i+1].children[0].element.text = inputLetter;
        }
    }

    for (k=cloneSelectedWordKeys.length-1; k>=0; k--) {
        
         if (cloneSelectedWordKeys[k] == inputLetter) {
              cloneSelectedWordKeys.splice(k, 1); 
         }
    }
};

EventsManager.prototype.convertOperatorToCharacter = function(operator) {
    if (operator == "addition") { return "+"; }
    else if(operator == "subtraction") { return "-"; }
    else if( operator == "multiplication") { return "x"; }
    else if (operator == "division") { return "/"; }
};


EventsManager.prototype.changeEventsWallActive = function (activeWallStatus) {

    if (activeWallStatus == true) {
        this.EventsTopWall.enabled = true;
        this.JokerWall.collision.halfExtents = new pc.Vec3(1.151, 20, 1.744);
        SafeAreaGamePlay.instance.updateEventWall();
    }
    else {
        this.EventsTopWall.enabled = false;
        this.JokerWall.collision.halfExtents = new pc.Vec3(1.151, 20, 1);
    }
};

EventsManager.prototype.OnDestroy = function(){
    this.entity.off("destroy", this.OnDestroy,this);
};



